module.exports = __webpack_public_path__ + "img/bg.25986291.jpeg";